import { get, post, put, patch } from "../HttpService";

export class SoftwareUpgradeService {
  static modules = (queryData = {}, config = {}) => {
    return get(`sw_upgrade`, queryData, config);
  };
  static search = (queryData = {}, config = {}) => {
    return get(`sw_upgrade`, queryData, config);
  };
  static addModule = (queryData = {}, config = {}) => {
    return post(`sw_upgrade`, queryData, config);
  };
  static editModule = (swId, queryData = {}, config = {}) => {
    return put(`sw_upgrade/${swId}`, queryData, config);
  };
  static upgradeModule = ( queryData = {}, config = {}) => {
    return put(`/sw_upgrade/upgrade_device`, queryData, config);
  };
  static cancelUpdate = (queryData = {}) => {
    return put(`sw_upgrade/cancel_upgrade`, queryData);
  };
  static advancedSearch = (queryData = {}, config = {}) => {
    return get(`sw_upgrade/search_device`, queryData, config);
  };
}
